export interface SelectOption {
  value: number | string | null;
  label?: string;
}

type SelectValue = SelectOption | (SelectOption | null | undefined)[] | null | undefined;

export const mapToOptionArray = (value: SelectValue) => {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value;
  }

  return [value];
};

export const mapMultiSelectToRelation = (value: SelectValue) => {
  return mapToOptionArray(value)
    .map((item) => {
      if (!item || item.value === null || item.value === undefined) {
        return null;
      }

      const normalizedValue =
        typeof item.value === 'string' && !Number.isNaN(Number(item.value))
          ? Number(item.value)
          : item.value;

      return { id: normalizedValue };
    })
    .filter(Boolean);
};
